import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

export default styled(Paper)(({ intenseradius = false }) => ({
  borderRadius: intenseradius ? '46px' : '7px',
  padding: '0px 20px 20px 20px',
}));
